import { render, staticRenderFns } from "./TrangXemChucVu.vue?vue&type=template&id=5204cbe9&"
import script from "./TrangXemChucVu.vue?vue&type=script&lang=js&"
export * from "./TrangXemChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports